import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
    border: none;
    background: none;
    padding: 4px;
    cursor: pointer;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 10px;
    font-size: 10px;
    user-select: none;
    color: ${({ theme }) => theme.gray6};
`;

export const ARROWDIRECTION = {
    UP : 'up',
    DOWN : 'down'
};

const ArrowButton = ({
    direction = ARROWDIRECTION.UP,
    onClick
}: {
    direction?: typeof ARROWDIRECTION[keyof typeof ARROWDIRECTION];
    onClick: () => void;
}) => {
    const isUp = direction === ARROWDIRECTION.UP;

    const timeoutRef = useRef<number | null>(null);
    const intervalRef = useRef<number | null>(null);

    const startCounter = () => {
        onClick(); // Register immediate click
        timeoutRef.current = window.setTimeout(() => {
            intervalRef.current = window.setInterval(() => {
                onClick();
            }, 100);
        }, 300); // Delay before repeat
    };

    const stopCounter = () => {
        if (timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    useEffect(() => {
        return () => {
            stopCounter();
        };
    }, []);

    return (
        <StyledButton
            type="button"
            onMouseDown={startCounter}
            onMouseUp={stopCounter}
            onMouseLeave={stopCounter}
        >
            {isUp ? '▲' : '▼'}
        </StyledButton>
    );
};

export default ArrowButton;
